module.exports = require("react-dev-utils/browsersHelper");